module.exports = __webpack_public_path__ + "static/media/branded-invoice-square.016390ab.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/upgradeReason/branded-invoice-square.svg
// module id = 1519
// module chunks = 0